import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZSpecCommon } from "src/business/specification";

import { AttributesTransfer } from "./AttributesTransfer";
import { AttributesTransferStore } from "./AttributesTransferStore";
import { AttrDetails } from "./AttrTransferPart/buildAttrsList";

type PropsAttributesTransferModal = {
  open: boolean;
  close: () => void;
  specs: ZSpecCommon[];
  initialAttrIds: string[];
  onApply: (newAttrIds: AttrDetails[]) => void;
};

export const AttributesTransferModal: React.FC<PropsAttributesTransferModal> =
  observer((props) => {
    const { open, close, specs, initialAttrIds, onApply } = props;
    const [store, setStore] = React.useState<
      AttributesTransferStore | undefined
    >();
    React.useEffect(() => {
      setStore(
        open ? new AttributesTransferStore(specs, initialAttrIds) : undefined,
      );
    }, [open]);
    const onOk = () => {
      if (store) onApply(store.right.attrList);
      close();
    };
    return (
      <Modal
        title="Выберите атрибуты"
        okText="Выбрать"
        open={open}
        onCancel={close}
        width="90vw"
        centered
        styles={{ body: { height: "calc(80vh - 60px)", overflow: "auto" } }}
        maskClosable={false}
        onOk={onOk}
        okButtonProps={{ disabled: !store?.right.attrList.length }}
      >
        {store && <AttributesTransfer store={store} />}
      </Modal>
    );
  });
